import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

import { ROUTER_TYPES } from '../../utils/constants';
import './SecondLevelNav.sass';

interface Props {
	isOpen: boolean;
}
function SecondLevelNav({ isOpen }: Props) {
	return (
		<div
			className={`second-level-nav${
				isOpen ? '' : ' second-level-nav--disabled'
			}`}
		>
			<Container>
				<Row>
					<Col xs={{ offset: 2, span: 10 }}>
						<nav className="second-level-nav__links">
							<NavLink to={ROUTER_TYPES.about}>About the Conference</NavLink>
							<NavLink to={ROUTER_TYPES.policy}>Privacy Policy</NavLink>
							<NavLink to={ROUTER_TYPES.codeOfConduct}>Code of Conduct</NavLink>
						</nav>
					</Col>
				</Row>
			</Container>
		</div>
	);
}

export default SecondLevelNav;
